// extracted by mini-css-extract-plugin
export default {"companyContainer":"kO-z","companyImage":"lO-z","container":"mO-z","heading":"nO-z","darkText":"oO-z","smallHeading":"pO-z","darkBackground":"qO-z","whiteBackground":"rO-z"};